module.exports = __webpack_public_path__ + "static/media/22.fc0edeab.svg";